import { createPhaseActions, phaseAction } from 'src/helpers/redux'
import * as agentsTypes from 'src/services/agents/types'
import { IAssistantContext, IWindow } from './state'

export const PREFIX = `assistant`
export const PREFIX_SAGA = `${PREFIX}/sagas`

type AssistantParams<Params> = Omit<Params, 'resourceId' | 'agentId'>

export const actions = createPhaseActions(PREFIX_SAGA, {
  openWindow: phaseAction<void>(),
  closeWidow: phaseAction<void>(),
  toogleWindow: phaseAction<void>(),
  updateWindow: phaseAction<Partial<IWindow>>(),
  updateContext: phaseAction<IAssistantContext | undefined>(),
  sendMessage: phaseAction<{ threadId: string; text: string }>(),
  resumePlan: phaseAction<{
    threadId: string
    approved: boolean
    comment?: string
  }>(),

  getMemoryThreadsPaginated:
    phaseAction<
      AssistantParams<agentsTypes.IGetMemoryThreadsPaginatedParams>
    >(),
  postMemoryThreads:
    phaseAction<AssistantParams<agentsTypes.IPostMemoryThreadsParams>>(),
  patchMemoryThreadsItem:
    phaseAction<AssistantParams<agentsTypes.IPatchMemoryThreadsItemParams>>(),
  deleteMemoryThreadsItem:
    phaseAction<AssistantParams<agentsTypes.IDeleteMemoryThreadsItemParams>>(),
  getMemoryThreadsItemMessages:
    phaseAction<
      AssistantParams<agentsTypes.IGetMemoryThreadsItemMessagesParams>
    >(),

  logging: phaseAction<void>(),
  cacheStorage: phaseAction<void>(),
  streamMessage: phaseAction<agentsTypes.ICRMAgentStreamParams>(),
  streamMessageCancel: phaseAction<{ threadId: string }>(),
})

export type Actions = typeof actions
